import PropTypes from 'prop-types';
import React from 'react';
import {Button} from 'semantic-ui-react';

import Table from '@appComponents/Table';
import ExcelExportButton from '@appComponents/ExcelExportButton';
import {hideModal} from '@utils/modal';
import {exportArgosJobHistoryExcel} from '@modules/events/utils/export/argosJobHistoryExcel';

import {jobHistoryColumns, jobHistoryRowRenderer} from '../../utils/argosHistoryTableHelper';

export const ArgosJobHistoryModal = ({jobId, job}) => {
    const jobHistory = (job?.live_job?.job_history || []).map((entry, idx) => ({...entry, id: `${idx}-${entry.ts}-${entry.state}`}));

    return (
        <div className='argos-history-modal'>
            <span className='argos-history-modal__title'>{`Argos job ${jobId} - Job history`}</span>
            <span className='argos-history-modal__divider-top'/>
            <div className='argos-history-modal__export'>
                <ExcelExportButton
                    exportExcelParams={exportArgosJobHistoryExcel(jobId, jobHistory)}
                    loading={false}
                />
            </div>
            <Table
                name='argosJobHistoryTable'
                columns={jobHistoryColumns}
                data={jobHistory}
                rowRenderer={jobHistoryRowRenderer}
                defaultSort='ts'
                defaultSortDirection='DESC'
                limit={50}
                size='small'
            />
            <span className='argos-history-modal__divider-bottom'/>
            <div className='argos-history-modal__close'>
                <Button
                    icon='remove'
                    content='Close'
                    onClick={hideModal}
                />
            </div>
        </div>
    );
};

ArgosJobHistoryModal.propTypes = {
    jobId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    job: PropTypes.shape({
        id: PropTypes.string,
        live_job: PropTypes.shape({
            job_history: PropTypes.arrayOf(PropTypes.shape({
                ts: PropTypes.string,
                state: PropTypes.string,
            })),
        }),
    }),
};

ArgosJobHistoryModal.defaultProps = {
    job: null,
};

export default ArgosJobHistoryModal;
